export const useFetchWithBaseUrl = async (url: string, options?: any) => {
    const config = useRuntimeConfig();
    return useFetch(config.public.apiBase + url, options);
};
